import { Plugin } from "grapesjs";
import loadComponents from "./components";
import loadBlocks from "./block";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "reliable-multi-section",
    label: "Multi Sections",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "reliable-multi-section",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
